<template>
    <div>
        <Modal v-model="show"
            :width="1200"
            :footer-hide="true"
            title="预发货单"
            @on-visible-change="onShowChange">
            <Spin v-if="innerSpin"
                size="large"
                fix></Spin>
            <Card :padding="0"
                :bordered="false"
                :dis-hover="true">
                <Row :gutter="16">
                    <Col span="24">
                    <Form ref="deliveryForm"
                        label-position="top">
                        <Row :gutter="16">
                            <Col span="3">
                            <FormItem label="定单时间">
                                <Input :value="formatDateTimeString(orderRecord.preSaleOrderRecordCreateAt)"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="4">
                            <FormItem label="定单编号">
                                <Input :value="orderRecord.preSaleOrderRecordCode"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="4">
                            <FormItem label="会员名称">
                                <Input :value="orderRecord.deliveryAddressContacts"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="4">
                            <FormItem label="会员电话">
                                <Input :value="orderRecord.deliveryAddressPhone"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="3">
                            <FormItem label="定单状态">
                                <Input :value="orderRecord.preSaleOrderRecordOrderStatus"
                                    readonly></Input>
                            </FormItem>
                            </Col>

                            <Col span="3">
                            <FormItem label="本定单合计">
                                <currency-input :value="orderRecord.preSaleOrderRecordTotalOrderCost"
                                    readonly />
                            </FormItem>
                            </Col>
                        </Row>

                        <Row :gutter="16">
                            <Col span="6">
                            <FormItem label="收货地址">
                                <Input :value="orderRecord.deliveryAddressFull"
                                    readonly></Input>
                            </FormItem>
                            </Col>
                            <Col span="3">
                            <FormItem label="发货日期"
                                prop="preSaleDeliveryRecordDeliveryDate">
                                <DatePicker :value="deliveryTable.form.preSaleDeliveryRecordDeliveryDate"
                                    :options="deliveryDateOptions"
                                    type="date"
                                    format="yyyy-MM-dd"
                                    @on-change="onDeliveryDateChange" />
                            </FormItem>
                            </Col>

                            <Col span="7">
                            <FormItem label="备注">
                                <Input v-model="deliveryTable.form.preSaleDeliveryRecordRemark"></Input>
                            </FormItem>
                            </Col>

                            <Col span="4">
                            <FormItem label=" ">
                                <Button type="success"
                                    @click="onSubmit">提交预发货单
                                </Button>
                            </FormItem>
                            </Col>
                        </Row>

                        <Row :gutter="16">
                            <Col span="24">
                            <div style="display:flex;justify-content: space-between;">
                                <span>定单商品</span>
                                <div style="display:flex;align-items: center;width:300px;margin-bottom:4px;">
                                    <Checkbox v-model="enableManualPromotion"
                                        @on-change="onEnablePromotion">启用人工优惠</Checkbox>
                                    <Select v-model="selectedManualPromotionUuid"
                                        @on-change="onPromotionChange"
                                        size="small"
                                        :disabled="enableManualPromotion === false"
                                        style="margin-left:10px;width:180px;">
                                        <Option v-for="promotion in manualPromotionList"
                                            :key="promotion.seedFarmManualPromotionUuid"
                                            :value="promotion.seedFarmManualPromotionUuid">{{ promotion.seedFarmManualPromotionName + '，优惠:' + promotion.seedFarmManualPromotionDiscount }}
                                        </Option>
                                    </Select>
                                </div>
                            </div>
                            <Table ref="mainTable"
                                size="small"
                                @on-select="onRowSelect"
                                @on-select-cancel="onRowSelectCancel"
                                @on-select-all="onSelectAll"
                                @on-select-all-cancel="onSelectAllCancel"
                                :columns="orderDetail.columns"
                                :data="orderDetail.rows"
                                :height="200"
                                stripe
                                border />
                            </Col>

                            <Col span="24">
                            <div style="display:flex;justify-content: space-between;">
                                <span>本次发货商品</span>
                                <div>
                                    <span style="color:red;font-size:16px;">合计发货量:{{deliveryTable.totalQuantity}}</span>
                                    <span style="color:red;font-size:16px; margin-left:20px;">合计发货金额:{{numberToFixed(deliveryTable.totalValue, 2)}}</span>
                                </div>
                            </div>
                            <Table ref="deliveryTable"
                                size="small"
                                :columns="deliveryTable.columns"
                                :data="deliveryTable.rows"
                                :height="200"
                                stripe
                                border />
                            </Col>
                        </Row>
                    </Form>
                    </Col>
                </Row>
                <Modal v-model="warehouseModal.show"
                    :title="`请填写预发货的数量`"
                    width="75"
                    @on-ok="onAddProducts">
                    <Row :gutter="16">
                        <Col span="24">
                        <Table ref="warehouseTable"
                            size="small"
                            :columns="warehouseModal.warehouseTable.columns"
                            :data="warehouseModal.warehouseTable.rows"
                            stripe
                            border />
                        </Col>
                        <div style="float:right;margin-right:10px;marign-top:10px;font-size:16px;">发货总量: {{warehouseModal.warehouseTable.totalQuantity}}</div>
                    </Row>
                </Modal>
            </Card>
        </Modal>
        <Modal v-model="bufferEditModal.show"
            title="修改产品缓冲设置"
            @on-ok="onUpdateBuffer">
            <Form label-position="top"
                class="form-input-no-outline">
                <Row :gutter="16">
                    <Col span="12">
                    <FormItem label="预售发货缓冲天数（天）">
                        <integer-input v-model="bufferEditModal.form.preSaleOrderDetailDeliveryDayBuffer"
                            :min="0"
                            :max="100" />
                    </FormItem>
                    </Col>

                    <Col span="12">
                    <FormItem label="预售发货缓冲量（%））">
                        <integer-input v-model="bufferEditModal.form.preSaleOrderDetailDeliveryQuantityBuffer"
                            :min="0"
                            :max="100" />
                    </FormItem>
                    </Col>
                </Row>
            </Form>
        </Modal>
    </div>

</template>

<script>
import { formatDateTimeString } from '@/libs/logic';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import DecimalInput from '@/components/number-input/decimal-input';
import IntegerInput from '@/components/number-input/integer-input';
import CurrencyInput from '@/components/number-input/currency-input';
import { dateRender } from '@/libs/tableRowTimeRender';
import { numberToFixed } from '@/components/number-input/display-format';

import { getOrderDeliveryHistory, pageInit4PreSaleOrderDelivery, savePreSaleForwardDelivery, updatePreSaleOrderBufferSetting, zeroDeliveryPreSaleOrderDetail } from '@/api/modules/preSale-management/preSale-order';
import { getSeedFarmManualPromotionList } from '@/api/modules/system-management/seedFarm-management';

export default {
    name: 'PreSaleOrderDelivery',
    components: {
        DecimalInput,
        IntegerInput,
        CurrencyInput,
        StandPaginationTable
    },
    data() {
        const now = new Date();
        const todayValue = new Date(now.getFullYear(), now.getMonth(), now.getDate()).valueOf();

        return {
            show: false,
            innerSpin: false,
            orderUuid: '',
            preSaleOrderRecordUuid: '',
            btnLoading: false,
            bufferEditModal: {
                show: false,
                form: {
                    preSaleOrderDetailUuid: '',
                    preSaleOrderDetailDeliveryDayBuffer: 0,
                    preSaleOrderDetailDeliveryQuantityBuffer: 0
                }
            },
            orderRecord: {
                preSaleOrderRecordCreateAt: '',
                preSaleOrderRecordCode: '',
                preSaleOrderRecordOrderStatus: '',
                preSaleOrderRecordTotalOrderCost: 0,
                deliveryAddressFull: '',
                region: ''
            },
            ruleValidate: {
                preSaleDeliveryRecordDeliveryDate: [{ required: true, message: ' ', trigger: 'blur' }],
                logisticsCompanyPriceChooseText: [{ required: true, message: ' ', trigger: 'blur' }]
            },
            orderDetail: {
                columns: [
                    { type: 'selection', width: 40, align: 'center' },
                    { title: '序号', key: 'index', width: 40, align: 'center' },
                    { title: '产品编码', key: 'preSaleOrderDetailProductCode', width: 80, align: 'center' },
                    { title: '产品名称', key: 'preSaleOrderDetailProductName', width: 130, align: 'center' },
                    { title: '预售周期', key: 'preSaleOrderDetailWeekKnownText', align: 'center' },
                    { title: '发货开始时间', key: 'preSaleOrderDetailDeliveryBeginDate', width: 80, align: 'center', render: (h, params) => dateRender(h, params.row.preSaleOrderDetailDeliveryBeginDate) },
                    { title: '发货结束时间', key: 'preSaleOrderDetailDeliveryEndDate', width: 80, align: 'center', render: (h, params) => dateRender(h, params.row.preSaleOrderDetailDeliveryEndDate) },
                    { title: '单价', key: 'preSaleOrderDetailProductDisplayPrice', align: 'center' },
                    { title: '定单数量', key: 'preSaleOrderDetailOrderQuantity', align: 'center' },
                    { title: '定单金额', key: 'preSaleOrderDetailTotalDisplayMoney', align: 'center' },
                    { title: '最小发货量', key: 'preSaleOrderDetailDeliveryMinQuantity', align: 'center' },
                    { title: '最大发货量', key: 'preSaleOrderDetailDeliveryMaxQuantity', align: 'center' },
                    { title: '已发货量', key: 'preSaleOrderDetailDeliveryQuantity', align: 'center' },
                    { title: '发货情况', key: 'preSaleOrderDetailDeliveryType', align: 'center' },
                    { title: '仓存量', key: 'storeSumAmount', align: 'center' },
                    {
                        title: '缓冲',
                        key: 'action',
                        align: 'center',
                        width: 60,
                        render: (h, params) => {
                            if (params.row.action === -1) {
                                return '';
                            }
                            else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        on: {
                                            click: () => {
                                                this.onEditBuffer(params.row);
                                            }
                                        }
                                    }, '编辑')
                                ]);
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        width: 110,
                        render: (h, params) => {
                            if (params.row.action === -1) {
                                return '';
                            }
                            else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            disabled: !params.row.canDelivery,
                                            size: 'small'
                                        },
                                        on: {
                                            click: () => {
                                                this.onShowWarehouseModal(params.row);
                                            }
                                        }
                                    }, '发货'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            disabled: !params.row.canDelivery || params.row.preSaleOrderDetailDeliveryType === '已发货',
                                            size: 'small'
                                        },
                                        style: {
                                            marginLeft: '4px'
                                        },
                                        on: {
                                            click: () => {
                                                this.zeroDelivery(params.row);
                                            }
                                        }
                                    }, '零发货')
                                ]);
                            }

                        }
                    }
                ],
                rows: []
            },
            deliveryTable: {
                columns: [
                    { title: '产品编码', key: 'preSaleOrderDetailProductCode', align: 'center' },
                    { title: '产品名称', key: 'preSaleOrderDetailProductName', align: 'center' },
                    { title: '预售周期', key: 'preSaleOrderDetailWeekKnownText', align: 'center' },
                    { title: '批次号', key: 'warehouseProductStoreBatchCode', align: 'center' },
                    { title: '销售周期', key: 'warehouseProductStoreSalePeriod', align: 'center' },
                    // { title: '入库价', key: 'warehouseProductStoreBatchPrice', align: 'center' },
                    { title: '发货仓', key: 'warehouseName', align: 'center' },
                    { title: '单价', key: 'preSaleOrderDetailProductDisplayPrice', align: 'center' },
                    { title: '优惠', key: 'discount', align: 'center' },
                    { title: '发货价', key: 'realPrice', align: 'center' },
                    {
                        title: '发货量',
                        align: 'center',
                        render: (h, params) => {
                            return h('Input', {
                                props: {
                                    value: params.row.deliveryQuantity,
                                    max: params.row.realMax,
                                    type: 'number',
                                    size: 'small'
                                },
                                on: {
                                    'on-keyup': event => {
                                        let intVal = parseInt(event.target.value);
                                        if (intVal < 0) {
                                            intVal = 0;
                                        }
                                        if (intVal > params.row.realMax) {
                                            intVal = params.row.realMax;
                                        }

                                        event.target.value = intVal;
                                        this.deliveryTable.rows[params.index].deliveryQuantity = intVal;
                                        this.deliveryTable.rows[params.index].deliveryValue
                                            = numberToFixed(intVal * this.deliveryTable.rows[params.index].realPrice, 2);
                                        this.calculateTotalDeliveryAmount();
                                    }
                                }
                            });
                        }
                    },
                    { title: '发货金额', key: 'deliveryValue', align: 'center' },
                    {
                        title: '操作',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.deliveryTable.rows.splice(params.index, 1);
                                        this.calculateTotalDeliveryAmount();
                                    }
                                }
                            }, '移除');
                        }
                    }
                ],
                rows: [],
                form: {
                    preSaleDeliveryRecordDeliveryDate: '',
                    preSaleDeliveryRecordRemark: ''
                },
                totalQuantity: 0,
                totalValue: 0
            },
            warehouseProductStores: [],
            warehouseModal: {
                show: false,
                preSaleOrderDetailObj: null,
                warehouseTable: {
                    columns: [
                        { type: 'selection', width: 60, align: 'center' },
                        { title: '仓存名称', key: 'warehouseName', align: 'center' },
                        { title: '批次号', key: 'warehouseProductStoreBatchCode', align: 'center' },
                        { title: '销售周期', key: 'warehouseProductStoreSalePeriod', align: 'center' },
                        // { title: '入库价', key: 'warehouseProductStoreBatchPrice', align: 'center' },
                        { title: '仓存数量', key: 'warehouseProductStoreAmount', align: 'center' },
                        {
                            title: '发货量',
                            align: 'center',
                            render: (h, params) => {
                                return h('Input', {
                                    props: {
                                        value: params.row.deliveryQuantity,
                                        max: params.row.realMax,
                                        type: 'number'
                                    },
                                    on: {
                                        'on-keyup': event => {
                                            let intVal = parseInt(event.target.value);
                                            if (intVal < 0) {
                                                intVal = 0;
                                            }
                                            if (intVal > params.row.realMax) {
                                                intVal = params.row.realMax;
                                            }

                                            event.target.value = intVal;
                                            this.warehouseModal.warehouseTable.rows[params.index].deliveryQuantity = intVal;
                                            this.warehouseModal.warehouseTable.rows[params.index]._checked = true;
                                            this.calculateTotalDeliveryAmountForSingleProduct();
                                        }
                                    }
                                });
                            }
                        }
                    ],
                    rows: [],
                    selection: [],
                    totalQuantity: 0
                }
            },
            historyTable: {
                columns: [
                    { title: '送货单号', key: 'preSaleDeliveryRecordCode', align: 'center' },
                    { title: '预售周期', key: 'preSaleOrderDetailWeekKnownText', align: 'center' },
                    { title: '发货日期', key: 'preSaleDeliveryRecordDeliveryDate', align: 'center', render: (h, params) => dateRender(h, params.row.preSaleDeliveryRecordDeliveryDate) },
                    { title: '制单日期', key: 'preSaleDeliveryRecordCreateAt', align: 'center', render: (h, params) => dateRender(h, params.row.preSaleDeliveryRecordCreateAt) },
                    { title: '产品编码', key: 'productCode', align: 'left' },
                    { title: '产品名称', key: 'productName', align: 'left' },
                    { title: '发货仓', key: 'warehouseName', align: 'left' },
                    { title: '发货量', key: 'preSaleDeliveryDetailQuantity', align: 'right' },
                    { title: '物流公司', key: 'preSaleDeliveryRecordLogisticsCompanyName', align: 'left' },
                    { title: '运费', key: 'preSaleDeliveryDetailTotalLogisticsPrice', align: 'right' },
                    { title: '定单价', key: 'preSaleOrderDetailProductDisplayPrice', align: 'right' },
                    { title: '最新价', key: 'preSaleDeliveryDetailLatestProductPrice', align: 'right' },
                    { title: '实价', key: 'preSaleDeliveryDetailActProductPrice', align: 'right' }
                ],
                rows: [],
                search: search.getSearchParams(),
                loading: false
            },
            deliveryDateOptions: {
                disabledDate(date) {
                    const v = date.valueOf();
                    return date && v < todayValue;
                }
            },
            manualPromotionList: [],
            enableManualPromotion: false,
            selectedManualPromotionUuid: '',
            promotionDiscount: 0
        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
                this.getManualPromotionList();
                this.enableManualPromotion = false;
                this.selectedManualPromotionUuid = '';
                this.deliveryTable.rows = [];
            }
        },
        showModal(orderUuid) {
            this.orderUuid = orderUuid;
            this.show = true;
        },
        formatDateTimeString,
        numberToFixed,
        init() {
            // const query = this.$route.query;
            if (this.orderUuid) {
                this.preSaleOrderRecordUuid = this.orderUuid;

                this.innerSpin = true;
                pageInit4PreSaleOrderDelivery(this.preSaleOrderRecordUuid).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        // 定单产品库存信息
                        this.warehouseProductStores = res.data.productStore;

                        const orderDetailRsp = res.data.orderDetail;
                        this.orderRecord = Object.assign(this.orderRecord, orderDetailRsp.orderRecord);
                        this.orderDetail.rows = orderDetailRsp.orderDetail.map(detail => {
                            const merge = Object.assign(detail, { storeSumAmount: 0 });

                            this.warehouseProductStores.forEach(s => {
                                if (s.warehouseProductStoreProductUuid === merge.preSaleOrderDetailProductUuid) {
                                    merge.storeSumAmount += s.warehouseProductStoreAmount;
                                }
                            });

                            return merge;
                        });

                        let index = 1;
                        this.orderDetail.rows.forEach(e => {
                            e.index = index++;
                            e._checked = true;
                            totalQuantity += e.preSaleOrderDetailOrderQuantity;
                            totalValue += e.preSaleOrderDetailTotalDisplayMoney;
                        });

                        // 历史送货单
                        this.historyTable.rows = res.data.deliveryHistory.records;
                        search.globalSetFilterRecordCount(this.historyTable.search, res.data.deliveryHistory.filterRecordCount);
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }
        },
        getManualPromotionList() {
            let tempSearch = search.getSearchParams();
            tempSearch.limit.enable = false;
            tempSearch.filters.enable = true;
            tempSearch.filters.conditions.push({
                name: 'seedFarmManualPromotionEnable',
                type: 'eq',
                value: 1
            });
            getSeedFarmManualPromotionList(tempSearch).then(res => {
                if (res.code === 0) {
                    this.manualPromotionList = [];
                    this.manualPromotionList = res.data.records;
                }
            });
        },
        onEnablePromotion() {
            if (this.enableManualPromotion) {
                this.onSelectAll();
            }
            else {
                this.onSelectAllCancel();
                this.selectedManualPromotionUuid = '';
                this.onPromotionChange();
            }
        },
        onPromotionChange() {
            let promotion = this.manualPromotionList.find(e => {
                return e.seedFarmManualPromotionUuid === this.selectedManualPromotionUuid;
            });
            if (promotion) {
                this.promotionDiscount = promotion.seedFarmManualPromotionDiscount;
            }
            else {
                this.promotionDiscount = 0;
            }

            if (this.deliveryTable.rows.length > 0) {
                this.deliveryTable.rows.forEach((e, index) => {
                    e.discount = e._checked ? this.promotionDiscount : 0;
                    e.realPrice = numberToFixed(e.preSaleOrderDetailProductDisplayPrice - e.discount, 4);
                    e.deliveryValue = numberToFixed(e.realPrice * e.deliveryQuantity, 2);
                    this.$set(this.deliveryTable.rows, index, e);
                });
                this.calculateTotalDeliveryAmount();
            }
        },
        onRowSelect(selection, row) {
            row._checked = true;
            this.$set(this.orderDetail.rows, row.index - 1, row);
        },
        onRowSelectCancel(selection, row) {
            row._checked = false;
            this.$set(this.orderDetail.rows, row.index - 1, row);
        },
        onSelectAll(selection) {
            this.orderDetail.rows.forEach((e, index) => {
                e._checked = true;
                this.$set(this.orderDetail.rows, index, e);
            });
        },
        onSelectAllCancel(selection) {
            this.orderDetail.rows.forEach((e, index) => {
                e._checked = false;
                this.$set(this.orderDetail.rows, index, e);
            });
        },
        calculateTotalDeliveryAmount() {
            this.deliveryTable.totalQuantity = this.deliveryTable.rows.map(e => {
                return e.deliveryQuantity;
            }).reduce((total, num) => {
                return total + num;
            });

            this.deliveryTable.totalValue = this.deliveryTable.rows.map(e => {
                return e.deliveryValue;
            }).reduce((total, num) => {
                return total + num;
            });
        },
        calculateTotalDeliveryAmountForSingleProduct() {
            this.warehouseModal.warehouseTable.totalQuantity = this.warehouseModal.warehouseTable.rows.map(e => {
                return e.deliveryQuantity;
            }).reduce((total, num) => {
                return total + num;
            }, 0);
        },
        onEditBuffer(row) {
            this.bufferEditModal.form.preSaleOrderDetailUuid = row.preSaleOrderDetailUuid;
            this.bufferEditModal.form.preSaleOrderDetailDeliveryQuantityBuffer = row.preSaleOrderDetailDeliveryQuantityBuffer;
            this.bufferEditModal.form.preSaleOrderDetailDeliveryDayBuffer = row.preSaleOrderDetailDeliveryDayBuffer;
            this.bufferEditModal.show = true;
        },
        onUpdateBuffer() {
            this.innerSpin = true;
            updatePreSaleOrderBufferSetting(this.bufferEditModal.form).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '更新成功',
                        content: '',
                        onOk: () => {
                            this.init();
                        }
                    });
                }
            }).catch(() => {
                this.innerSpin = false;
            });
        },
        zeroDelivery(row) {
            this.$Modal.confirm({
                title: '确认进行数量为零的发货？',
                onOk: () => {
                    this.innerSpin = true;
                    zeroDeliveryPreSaleOrderDetail({ preSaleOrderDetailUuid: row.preSaleOrderDetailUuid }).then(res => {
                        this.innerSpin = false;
                        if (res.code === 0) {
                            this.init();
                            this.$Message.success('操作成功');
                        }
                    });
                }
            });
        },
        onSubmit() {
            if (this.deliveryTable.form.preSaleDeliveryRecordDeliveryDate === '') {
                this.$Modal.error({ title: '发货日期不能为空', content: '' });
                return;
            }

            const submitData = {
                preSaleOrderRecordUuid: this.preSaleOrderRecordUuid,
                seedFarmManualPromotionUuid: this.selectedManualPromotionUuid,
                preSaleDeliveryRecordDeliveryDate: this.deliveryTable.form.preSaleDeliveryRecordDeliveryDate,
                preSaleDeliveryRecordRemark: this.deliveryTable.form.preSaleDeliveryRecordRemark,
                deliveryDeliveryDetails: this.deliveryTable.rows.map(r => {
                    return {
                        warehouseUuid: r.warehouseProductStoreWarehouseUuid,
                        batchCode: r.warehouseProductStoreBatchCode,
                        price: r.warehouseProductStoreBatchPrice,
                        salePeriod: r.warehouseProductStoreSalePeriod,
                        distributionStationUuid: r.preSaleOrderDetailRelateDistributionStationUuid,
                        preSaleOrderDetailUuid: r.preSaleOrderDetailUuid,
                        deliveryQuantity: r.deliveryQuantity,
                        enableManualPromotion: r._checked
                    };
                })
            };

            this.innerSpin = true;
            savePreSaleForwardDelivery(submitData).then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.show = false;
                            this.$parent.init();
                            // window.location.reload();
                        }
                    });
                }
            }).catch(() => {
                this.innerSpin = false;
            });
        },
        onShowWarehouseModal(row) {
            this.warehouseModal.preSaleOrderDetailObj = row;

            const realMax = row.preSaleOrderDetailDeliveryMaxQuantity <= row.storeSumAmount ? row.preSaleOrderDetailDeliveryMaxQuantity : row.storeSumAmount;
            const productUuid = row.preSaleOrderDetailProductUuid;

            this.warehouseModal.warehouseTable.rows = this.warehouseProductStores
                .filter(p => p.warehouseProductStoreProductUuid === productUuid)
                .map(p => {
                    return Object.assign({
                        preSaleOrderDetailDeliveryMinQuantity: row.preSaleOrderDetailDeliveryMinQuantity,
                        preSaleOrderDetailDeliveryMaxQuantity: row.preSaleOrderDetailDeliveryMaxQuantity,
                        realMax: realMax,
                        preSaleOrderDetailWeekKnownText: row.preSaleOrderDetailWeekKnownText,
                        deliveryQuantity: 0,
                        preSaleOrderDetailProductUuid: productUuid
                    }, p);
                });

            let leftQuantity = row.preSaleOrderDetailOrderQuantity;
            for (let i = 0; i < this.warehouseModal.warehouseTable.rows.length; i++) {
                const e = this.warehouseModal.warehouseTable.rows[i];
                if (e.warehouseProductStoreAmount >= leftQuantity) {
                    this.warehouseModal.warehouseTable.rows[i].deliveryQuantity = leftQuantity;
                    this.warehouseModal.warehouseTable.rows[i]._checked = true;
                    break;
                }
                else {
                    this.warehouseModal.warehouseTable.rows[i].deliveryQuantity = e.warehouseProductStoreAmount;
                    this.warehouseModal.warehouseTable.rows[i]._checked = true;
                    leftQuantity = leftQuantity - e.warehouseProductStoreAmount;
                }
                if (leftQuantity === 0) {
                    break;
                }
            }
            //查找第一个满足量的,自动填写默认值,并且自动选中
            // let warehouseIndex = this.warehouseModal.warehouseTable.rows.findIndex(e => {
            //     return e.warehouseProductStoreAmount >= row.preSaleOrderDetailOrderQuantity;
            // });
            // if (warehouseIndex != -1) {
            //     this.warehouseModal.warehouseTable.rows[warehouseIndex].deliveryQuantity = row.preSaleOrderDetailOrderQuantity;
            //     this.warehouseModal.warehouseTable.rows[warehouseIndex]._checked = true;
            // }

            //当库存批次只有一个时，存量充足时，自动填写默认值,并且自动选中
            // if (this.warehouseModal.warehouseTable.rows.length === 1) {
            //     if (this.warehouseModal.warehouseTable.rows[0].realMax >= row.preSaleOrderDetailOrderQuantity) {
            //         this.warehouseModal.warehouseTable.rows[0].deliveryQuantity = row.preSaleOrderDetailOrderQuantity;
            //         this.warehouseModal.warehouseTable.rows[0]._checked = true;
            //     }
            // }
            this.warehouseModal.warehouseTable.selection = [];
            this.calculateTotalDeliveryAmountForSingleProduct();
            this.warehouseModal.show = true;
        },
        onAddProducts() {
            const that = this;
            // const avaliable = this.warehouseModal.warehouseTable.rows.filter(r => r.deliveryQuantity > 0);
            this.warehouseModal.warehouseTable.selection = this.$refs.warehouseTable.getSelection();
            if (this.warehouseModal.warehouseTable.selection.length > 0) {
                this.warehouseModal.warehouseTable.selection.forEach(item => {
                    const existsIndex = this.deliveryTable.rows.findIndex(
                        d => d.warehouseProductStoreWarehouseUuid === item.warehouseProductStoreWarehouseUuid
                            && d.warehouseProductStoreBatchCode === item.warehouseProductStoreBatchCode
                            && d.warehouseProductStoreBatchPrice === item.warehouseProductStoreBatchPrice
                            && d.warehouseProductStoreSalePeriod === item.warehouseProductStoreSalePeriod
                            && d.preSaleOrderDetailProductUuid === item.preSaleOrderDetailProductUuid
                            && d.preSaleOrderDetailWeekKnownText === item.preSaleOrderDetailWeekKnownText);

                    if (existsIndex >= 0) {
                        that.deliveryTable.rows[existsIndex].deliveryQuantity = item.deliveryQuantity;
                        that.deliveryTable.rows[existsIndex].discount = item._checked ? this.promotionDiscount : 0;
                        that.deliveryTable.rows[existsIndex].realPrice
                            = numberToFixed(that.deliveryTable.rows[existsIndex].preSaleOrderDetailProductDisplayPrice - that.deliveryTable.rows[existsIndex].discount, 4);
                        that.deliveryTable.rows[existsIndex].deliveryValue
                            = numberToFixed(that.deliveryTable.rows[existsIndex].deliveryQuantity * that.deliveryTable.rows[existsIndex].realPrice, 2);

                    }
                    else {
                        let newRow = Object.assign(item, this.warehouseModal.preSaleOrderDetailObj);
                        newRow.discount = item._checked ? this.promotionDiscount : 0;
                        newRow.realPrice = numberToFixed(newRow.preSaleOrderDetailProductDisplayPrice - newRow.discount, 4);
                        newRow.deliveryValue = numberToFixed(newRow.deliveryQuantity * newRow.realPrice, 2);
                        that.deliveryTable.rows.push(newRow);
                    }
                });
                this.calculateTotalDeliveryAmount();
            }
            else {
                this.$Modal.error({
                    title: '未选择预发货商品'
                });
            }
        },
        getHistoryTableRecord(reset = false) {
            const queryData = Object.assign(this.historyTable.search, {
                preSaleOrderRecordUuid: this.preSaleOrderRecordUuid
            });

            if (reset) {
                search.globalResetSearch(this.historyTable.search);
            }

            getOrderDeliveryHistory(queryData).then(res => {
                if (res.code === 0) {
                    this.historyTable.rows = res.data.records;
                    search.globalSetFilterRecordCount(this.historyTable.search, res.data.filterRecordCount);
                }
            }).catch(() => {

            });
        },
        onDeliveryDateChange(date) {
            this.deliveryTable.form.preSaleDeliveryRecordDeliveryDate = date;
        }
    }
};
</script>

<style scoped>
</style>
